import { useEffect } from 'react';
import {
  useExludeActiveCustomerMutation,
  showToast,
  ErrorVariants,
  dispatch,
  updateSelectedItemIds,
  clearSelectedItemIds,
  ActiveCustomer,
  useAppSelector,
  getWorkspaceId,
  getAppState,
  APP_TYPE,
} from '@zonofi/zono-money-store';
import { useNavigate } from 'react-router-dom';
import { FIELD_OPS_ROUTES, SELLER_WEBAPP_ROUTES } from '../../constants';

interface UseExcludeCustomersOptions {
  inviteIds: string[];
  exclude: boolean;
  refetchCustomers?: () => void;
  onSuccessCall?: () => void;
  onErrorCall?: () => void;
  successMessage?: string;
  errorMessage?: string;
}

export const useExcludeCustomers = ({
  inviteIds,
  exclude,
  refetchCustomers,
  onSuccessCall,
  onErrorCall,
  successMessage = 'Customer(s) updated successfully',
  errorMessage = 'Error Occurred',
}: UseExcludeCustomersOptions) => {
  const navigate = useNavigate();
  const appState = useAppSelector(getAppState);
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);

  const [updateExcludeCustomers, updateExcludeCustomersResponse] =
    useExludeActiveCustomerMutation();

  const onExcludedCustomerPress = () => {
    updateExcludeCustomers({
      sellerWorkspaceId,
      exclude,
      inviteIds,
    });
  };

  useEffect(() => {
    return () => {
      dispatch(clearSelectedItemIds());
    };
  }, []);

  useEffect(() => {
    if (updateExcludeCustomersResponse.isSuccess) {
      dispatch(
        showToast({
          message: successMessage,
          type: ErrorVariants.SUCCESS,
          canDisplay: true,
          responseStatus: 'Success',
        })
      );
      refetchCustomers?.();
      onSuccessCall?.();
    } else if (updateExcludeCustomersResponse.isError) {
      dispatch(
        showToast({
          message: errorMessage,
          type: ErrorVariants.DANGER,
          canDisplay: true,
          responseStatus: 'Danger',
        })
      );
      onErrorCall?.();
    }
  }, [updateExcludeCustomersResponse]);

  const onCustomerItemPress = (customer: ActiveCustomer) => {
    const routeToNavigate =
      appState === APP_TYPE.FIELDS_OPS
        ? `${FIELD_OPS_ROUTES.CUSTOMER_PROFILE}/${customer.inviteId}`
        : `${SELLER_WEBAPP_ROUTES.CUSTOMER_DETAILS}/${customer.inviteId}`;
    navigate(routeToNavigate);
  };

  return {
    onExcludedCustomerPress,
    isExcludeLoading: updateExcludeCustomersResponse.isLoading,
    onCustomerCheckBox: (customer: ActiveCustomer) =>
      dispatch(updateSelectedItemIds(customer.inviteId)),
    onCustomerItemPress,
  };
};
